import React from 'react';
import className from 'classnames';
import PropTypes from 'prop-types';
import { ABUtils, Config } from '../../utils';

export const DropdownItem = ({ children, onClick, iconClass, isNested, isSelected, isFixedWidth, iataCode, isShowIcon }) => {
    const { isCssVariation, isCssVariationDesktop } = ABUtils.getABs();
    const itemClassNames = className({
        'odf-dropdown-item odf-dropdown-row': !isCssVariation,
        'prisma-responsive-space-horizontal prisma-dropdown-item': isCssVariation,
        'odf-separator-dotted odf-space-inner-top-l odf-space-inner-bottom-l': isCssVariation,
        'odf-space-inner-right-l odf-space-inner-left-l': isCssVariationDesktop,
        'nested': isNested && !isCssVariation,
        'hover': isSelected,
    });
    const hasIcon = iconClass !== '';
    const hasImage = isCssVariation && !isShowIcon && !isNested;
    const textWrapperClassNames = className({
        'odf-dropdown-col lg': true,
        'odf-text-nowrap': !isFixedWidth,
    });
    const paddingDropdown = isCssVariation ? { paddingTop: 0, paddingBottom: 0 } : {};
    return (
        <li className={itemClassNames} onClick={onClick}>
            {hasIcon && !hasImage && (
                <div className="odf-dropdown-col" style={paddingDropdown}>
                    <span className={`odf-dropdown-icon odf-icon ${iconClass}`} />
                </div>
            ) }
            { hasImage && (
                <div className="odf-dropdown-col" style={{ padding: 0 }}>
                    <div
                        className="odf-img-circle"
                        style={{
                            backgroundImage: `url(${Config.get('imgPath')}/onefront/destinations/64x64/empty.jpg)`,
                            backgroundPosition: 'center center',
                            width: '48px',
                            height: '48px',
                            verticalAlign: 'middle',
                        }}
                    >
                        { iataCode !== '' && (
                            <div
                                className="odf-img-circle"
                                style={{
                                    backgroundImage: `url(${Config.get('imgPath')}/onefront/destinations/64x64/${iataCode}.jpg)`,
                                    backgroundPosition: 'center center',
                                    width: '48px',
                                    height: '48px',
                                    verticalAlign: 'middle',
                                }}
                            />
                        ) }
                    </div>
                </div>
            ) }
            <div className={textWrapperClassNames} style={paddingDropdown}>
                {children}
            </div>
            { iataCode && (
                <div className="odf-dropdown-col" style={{ ...paddingDropdown, paddingRight: 0 }}>
                    <span className="odf-dropdown-badge odf-fixed-width odf-dropdown-extra">{iataCode}</span>
                </div>
            ) }
        </li>
    );
};

DropdownItem.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    iconClass: PropTypes.string,
    isNested: PropTypes.bool,
    isSelected: PropTypes.bool,
    isFixedWidth: PropTypes.bool,
    iataCode: PropTypes.string,
    isShowIcon: PropTypes.bool,
};

DropdownItem.defaultProps = {
    children: React.Fragment,
    onClick: () => {},
    iconClass: '',
    isNested: false,
    isSelected: false,
    isFixedWidth: false,
    iataCode: '',
    isShowIcon: false,
};
